import { checkIsHoliday } from "api/queries/holiday";
import { useQuery, UseQueryOptions, UseQueryResult } from "react-query";
import { IGetHolidayResponse } from "rules/interface/api/holiday/holiday.interface";
import { IServerGetResponse } from "rules/interface/api/response";

interface IProps {
    params: {
        date: string
    },
    options: UseQueryOptions<undefined, undefined>
}

export const useCheckIsHoliday = ({ params, options }: IProps): UseQueryResult<IServerGetResponse<IGetHolidayResponse>> => {
    return useQuery(
        ["check-is-holiday", params],
        () =>
            checkIsHoliday(params),
        options
    );
};